import { render, staticRenderFns } from "./permissionModal.vue?vue&type=template&id=2c9c4788&"
import script from "./permissionModal.vue?vue&type=script&lang=ts&"
export * from "./permissionModal.vue?vue&type=script&lang=ts&"
import style0 from "./permissionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports